import "./Table.scss";

import config from "../../../config";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_TABLE, ROUTE_MAP } from "../../routes";
import { STORE_TABLE, SORT_ASC, SORT_DESC } from "../../Store/TableStore";
import {
  PALLET_COLORS,
  COLOR_FILTER_NONE,
  getPalletColor,
} from "./palletColors";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";
import { BiCheck } from "react-icons/bi";

const SORT_ID = "Id";
const SORT_MACHINE = "Machine";
const SORT_CLEANINGRATE = "CleaningRateText";
const SORT_SUPPLIER = "Supplier";
const SORT_LOTNO = "LotNo";
const SORT_ITEM = "ItemName";
const SORT_LOCATION = "BinCode";
const SORT_AMOUNT = "Quantity";
const SORT_QPURITY = "Purity";
const SORT_QALIENSEED = "Alienseed";
const SORT_QHARDSEED = "Hardseed";
const SORT_QGERM = "Germ";
const SORT_QWATER = "Water";
const SORT_CREATED = "Created";
const SORT_TERMINATED = "Terminated";
const SORT_STATUS = "Status";

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const colorOptions = PALLET_COLORS.map((color) => ({
  value: color.id,
  label: color.name,
  color,
}));

const colorFilterOptions = [
  { value: null, label: "Összes" },
  { value: COLOR_FILTER_NONE, label: "Színezetlen" },
].concat(colorOptions);

const formatColorOption = (option) => (
  <div className="color-option">
    {option.color ? (
      <span
        className="color-option__swatch"
        style={{ backgroundColor: option.color.hex }}
      />
    ) : null}
    {option.label}
  </div>
);

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_TABLE),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.searchtext.length > 0 ? "" : " hidden");
    return (
      <div className="table-search">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.searchtext}
            onChange={(e) => store.setSearchText(e.target.value)}
          />
          <div
            className={cancelClassname}
            onClick={(e) => {
              store.setSearchText("");
              store.setSearch();
            }}
          >
            <i className="fas fa-times"></i>
          </div>
        </div>
        <div
          className="btn searchbutton"
          onClick={(e) => {
            store.setSearch(store.searchtext);
          }}
        >
          Keres
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_TABLE),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      showTerminated: false,
      from: null,
      to: null,
      subtable: null,
      selectedColor: null,
      coloring: false,
    };

    this.refresh();
  }
  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField === field) {
      store.flipSortDirection();
    } else {
      store.setSortField(field);
      store.setSortDirection(SORT_ASC);
    }
  };
  onFileChange = async (e) => {
    const { store } = this.props;
    if (!e.target.files.length || store.uploading) return;
    const data = new FormData();
    data.append("file", e.target.files[0]);
    e.target.value = "";
    store.setUploading();
    try {
      const response = await axios.post(config.FILE_UPLOAD_URL(window), data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      this.setState({
        popup: "show",
        popupText: "Sikeres minőség feltöltés (" + response + " db).",
      });
    } catch (e) {
      console.error("feltöltés hiba: ", e);
      this.setState({
        popup: "show",
        popupText: "Sikertelen minőség feltöltés.",
      });
    } finally {
      store.setUploading(false);
      this.refresh();
    }
  };

  typedValue = (value) => {
    return {
      t: isNaN(value) ? "s" : "n",
      v: value,
    };
  };

  handleDownload() {
    const { store, configStore } = this.props;
    const { sortedItems, search } = store;
    const canColor = this.canColor();
    const { showTerminated } = this.state;

    const merges = [];
    let data = [
      [
        "Azonosító",
        ...(canColor ? ["Szín"] : []),
        "Gép",
        "Fok",
        "Beszállító",
        "Cikk",
        "Hely",
        "Mennyiség",
        "Összmennyiség",
        "Létrehozva",
        "Tisztaság %",
        "Hulladék %",
        "Idegenmag %",
        "Dátum",
        "Ép csíra",
        "Beteg csíra",
        "Rohadt",
        "Keménymag v. Léhamag",
        "Víz %",
        "Vad repce",
        "Repcsényretek",
        "Vadzab",
        "Aranka",
        "Rumex",
        "Tarackbúza",
        "Szklerocium",
        "Gabona",
        "Nem gabona",
        "Idegenmag darabszám",
        "Szerződés szerinti idegenmagok",
        "Egyéb adat",
        "Egyéb mag",
        "Egyéb megnevezés",
        "Vizsgálati dátum",
      ],
    ];
    if (showTerminated) data[0] = data[0].concat(["Megszüntetve", "Művelet"]);

    let rowindex = 1;

    sortedItems.forEach((pallet) => {
      const color = getPalletColor(pallet.Color);
      let row = [
        pallet.LotNo + (pallet.SealNum ? " (" + pallet.SealNum + ")" : ""),
        ...(canColor ? [color ? color.name : ""] : []),
        pallet.MachineText,
        pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : ""),
        (pallet.Supplier ? pallet.Supplier : "") +
          (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : ""),
        pallet.ItemName +
          (pallet.CustomItem ? " (" + pallet.CustomItem + ")" : ""),
        pallet.BinCode
          ? pallet.BinCode + (pallet.Level != null ? "/" + pallet.Level : "")
          : "",
        (pallet.BagType === 2
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg",
        pallet.BagCount * pallet.Quantity,
        pallet.Created,
        this.typedValue(
          pallet.Purity ||
            (pallet.QualityFull
              ? pallet.QualityFull[11] !== null
                ? pallet.QualityFull[11]
                : ""
              : pallet.QualityPurity !== null
              ? pallet.QualityPurity
              : "")
        ),
        this.typedValue(
          pallet.Waste ||
            (pallet.QualityFull
              ? pallet.QualityFull[12] !== null
                ? pallet.QualityFull[12]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Alienseed ||
            (pallet.QualityFull
              ? pallet.QualityFull[13] !== null
                ? pallet.QualityFull[13]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.QualityFull
            ? pallet.QualityFull[14] !== null
              ? pallet.QualityFull[14]
              : ""
            : ""
        ),
        this.typedValue(
          pallet.GermHealthy ||
            (pallet.QualityFull
              ? pallet.QualityFull[15] !== null
                ? pallet.QualityFull[15]
                : ""
              : pallet.QualityGerm !== null
              ? pallet.QualityGerm
              : "")
        ),
        this.typedValue(
          pallet.GermIll ||
            (pallet.QualityFull
              ? pallet.QualityFull[16] !== null
                ? pallet.QualityFull[16]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.GermRotten ||
            (pallet.QualityFull
              ? pallet.QualityFull[17] !== null
                ? pallet.QualityFull[17]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Hardseed ||
            (pallet.QualityFull
              ? pallet.QualityFull[18] !== null
                ? pallet.QualityFull[18]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Water ||
            (pallet.QualityFull
              ? pallet.QualityFull[19] !== null
                ? pallet.QualityFull[19]
                : ""
              : pallet.QualityWater !== null
              ? pallet.QualityWater
              : "")
        ),
        this.typedValue(
          pallet.Vadrepce ||
            (pallet.QualityFull
              ? pallet.QualityFull[20] !== null
                ? pallet.QualityFull[20]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Repcsenyretek ||
            (pallet.QualityFull
              ? pallet.QualityFull[21] !== null
                ? pallet.QualityFull[21]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Vadzab ||
            (pallet.QualityFull
              ? pallet.QualityFull[22] !== null
                ? pallet.QualityFull[22]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Aranka ||
            (pallet.QualityFull
              ? pallet.QualityFull[23] !== null
                ? pallet.QualityFull[23]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Rumex ||
            (pallet.QualityFull
              ? pallet.QualityFull[24] !== null
                ? pallet.QualityFull[24]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Tarackbuza ||
            (pallet.QualityFull
              ? pallet.QualityFull[25] !== null
                ? pallet.QualityFull[25]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Szklerocium ||
            (pallet.QualityFull
              ? pallet.QualityFull[26] !== null
                ? pallet.QualityFull[26]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Gabona ||
            (pallet.QualityFull
              ? pallet.QualityFull[27] !== null
                ? pallet.QualityFull[27]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.Nemgabona ||
            (pallet.QualityFull
              ? pallet.QualityFull[28] !== null
                ? pallet.QualityFull[28]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.AlienseedCount ||
            (pallet.QualityFull
              ? pallet.QualityFull[29] !== null
                ? pallet.QualityFull[29]
                : ""
              : "")
        ),
        this.typedValue(
          pallet.AlienseedContract ||
            (pallet.QualityFull
              ? pallet.QualityFull[30] !== null
                ? pallet.QualityFull[30]
                : ""
              : "")
        ),
        pallet.MiscData ||
          (pallet.QualityFull
            ? pallet.QualityFull[31] !== null
              ? pallet.QualityFull[31]
              : ""
            : ""),
        pallet.MiscSeed ||
          (pallet.QualityFull
            ? pallet.QualityFull[32] !== null
              ? pallet.QualityFull[32]
              : ""
            : ""),
        pallet.MiscTitle ||
          (pallet.QualityFull
            ? pallet.QualityFull[33] !== null
              ? pallet.QualityFull[33]
              : ""
            : ""),
        this.typedValue(
          pallet.QualityFull
            ? pallet.QualityFull[34] !== null
              ? pallet.QualityFull[34]
              : ""
            : ""
        ),
      ];

      if (showTerminated)
        row = row.concat([
          pallet.Terminated,
          configStore.palletstatuses[pallet.Status],
        ]);

      data.push(row);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "Táblázat");

    XLSX.writeFile(
      wb,
      `Táblázat_${formatDateOnly(new Date())} (${search.substring(
        0,
        14
      )}).xlsx`,
      {
        bookSST: true,
        compression: true,
      }
    );
  }

  refresh() {
    const { store, socket } = this.props;
    const { showTerminated } = this.state;

    if (showTerminated && !store.from) {
      const date = new Date();
      date.setMonth(date.getMonth() - 3);
      store.setFrom(date);
    }

    const data = {
      From: store.from ? store.fromFormatted : null,
      To: store.to ? store.toFormatted : null,
      ShowTerminated: showTerminated,
    };

    const _this = this;
    socket.emitWithToken("GetPallets", data, function (err, data) {
      if (err || !data) {
        console.error(err);
        _this.showPopup("Nem sikerült betölteni a raklapokat.");
        return;
      }
      store.setItems(data);
      _this.setState({ newContentAvailable: false });
    });
  }

  getPalletHistory(palletid) {
    const { store, socket } = this.props;

    const _palletid = palletid;

    socket.emitWithToken(
      "GetPalletHistory",
      { PalletId: _palletid },
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        store.setPalletHistory({ PalletId: _palletid, Data: data });
      }
    );
  }

  componentDidMount() {
    const { route, store, socket } = this.props;
    if (route.params.hasOwnProperty("search")) {
      store.setSearch(route.params.search);
    }

    socket.on("InventoryChanged", this.inventoryChanged);

    this.props.socket.emitWithToken(
      "GetSealnums",
      {},
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        store.setSealnums(data);
      },
      store
    );
  }

  componentWillUnmount() {
    this.props.socket.off("InventoryChanged", this.inventoryChanged);
  }

  inventoryChanged = (data) => {
    const { authStore } = this.props;
    if (data && data.UserId == authStore.user.Id) return;
    this.setState({ newContentAvailable: true });
  };

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  canColor() {
    const { authStore } = this.props;
    return !!(authStore.user && authStore.user.PalletColor);
  }

  toggleColoring() {
    const { store } = this.props;
    this.setState((prevState) => {
      if (prevState.coloring) {
        store.resetCheckedPallets();
        return { coloring: false, selectedColor: null };
      }
      return { coloring: true };
    });
  }

  setColor(color) {
    const { store, socket, authStore } = this.props;
    const palletids = store.checked.slice();
    if (palletids.length === 0) return;

    socket.emitWithToken(
      "SetPalletColor",
      { UserId: authStore.user.Id, PalletIds: palletids, Color: color },
      (err, data) => {
        if (err) {
          console.error(err);
          this.showPopup(err.Message || err);
          return;
        }
        store.setColor(palletids, color);
        store.resetCheckedPallets();
      }
    );
  }

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { shownItems, sortDirection, sortField, pager, uploading } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;
    const { showTerminated } = this.state;
    const canColor = this.canColor();
    const coloring = canColor && this.state.coloring;

    let rows = [];

    shownItems.forEach((pallet) => {
      store.palletHistory &&
        store.palletHistory.PalletId === pallet.Id &&
        console.log(configStore.machines);

      const subtable = (
        <tr
          key={"s" + pallet.Id}
          id={"s" + pallet.Id}
          className={
            "subtable" + (this.state.subtable === pallet.Id ? "" : " hidden")
          }
        >
          {store.palletHistory && store.palletHistory.PalletId === pallet.Id ? (
            <table>
              <tr>
                <th>Gép</th>
                <th>Fok</th>
                <th>Mennyiség</th>
                <th>Tisztaság</th>
                <th>Idegenmag</th>
                <th>Keménymag</th>
                <th>Csíra</th>
                <th>Víz</th>
                <th>Létrehozva</th>
                <th>Megszüntetve</th>
              </tr>
              {store.palletHistory.Data.map((pallet) => {
                console.log(pallet);
                return (
                  <tr>
                    <td>
                      {configStore.machines[pallet.MachineId].Name +
                        (pallet.CleaningCount
                          ? " x" + pallet.CleaningCount
                          : "")}
                      {pallet.Dressing ? <br /> : null}{" "}
                      {pallet.Dressing ? "(" + pallet.Dressing + ")" : ""}
                    </td>
                    <td>
                      {
                        configStore.cleaningRates[pallet.CleaningRate].split(
                          "-"
                        )[0]
                      }
                    </td>
                    <td>
                      {pallet.BagType === 2
                        ? pallet.BagCount + " x " + pallet.Quantity
                        : pallet.Quantity}{" "}
                      kg
                    </td>
                    <td>
                      {pallet.QualityPurity ? pallet.QualityPurity + " %" : ""}
                    </td>
                    <td>
                      {pallet.QualityAlienseed
                        ? pallet.QualityAlienseed == -1.0
                          ? "Ny"
                          : pallet.QualityAlienseed + " %"
                        : ""}
                    </td>
                    <td>
                      {pallet.QualityHardseed
                        ? pallet.QualityHardseed + " %"
                        : ""}
                    </td>
                    <td>
                      {pallet.QualityGerm ? pallet.QualityGerm + " %" : ""}
                    </td>
                    <td>
                      {pallet.QualityWater ? pallet.QualityWater + " %" : ""}
                    </td>
                    <td>{formatDate(pallet.Created)}</td>
                    <td>
                      {pallet.Terminated ? formatDate(pallet.Terminated) : null}
                    </td>
                  </tr>
                );
              })}
            </table>
          ) : (
            <div>Előzmények...</div>
          )}
        </tr>
      );

      let status;
      switch (pallet.Status) {
        case 1:
          status = "Feldolgozva";
          break;
        case 2:
          status = "Értékesítve";
          break;
        case 3:
          status = "Törölve";
          break;
      }

      const color = canColor ? getPalletColor(pallet.Color) : null;
      rows.push(
        <tr key={pallet.Id}>
          {coloring ? (
            <td className="table-select-col">
              <div className="table-checkbox-block">
                <input
                  id={"checkpallet" + pallet.Id}
                  type="checkbox"
                  checked={store.isChecked(pallet.Id)}
                  onChange={() =>
                    store.setChecked(pallet.Id, !store.isChecked(pallet.Id))
                  }
                />
                <label htmlFor={"checkpallet" + pallet.Id}>
                  <span></span>
                </label>
              </div>
            </td>
          ) : null}
          <td
            className={"table-cell-active" + (color ? " colored-cell" : "")}
            style={
              color ? { backgroundColor: color.hex, color: color.text } : null
            }
            onClick={() => {
              this.getPalletHistory(pallet.Id);
              this.setState((prevState) => {
                return {
                  subtable: prevState.subtable === pallet.Id ? null : pallet.Id,
                };
              });
            }}
          >
            <span
              className={
                (pallet.CleaningCount > 1 ? "bold" : "normal") +
                (!pallet.ThisSeason ? " offseasonpallet" : "")
              }
            >
              {pallet.LotNo}
            </span>
            {pallet.SealNum ? <br /> : null}{" "}
            {pallet.SealNum ? "(" + pallet.SealNum + ")" : ""}
          </td>
          <td>
            <EditableField
              type="machine"
              pallet={pallet}
              store={store}
              configStore={configStore}
              userid={authStore.user.Id}
              socket={socket}
              showPopup={(text) => this.showPopup(text)}
            />
          </td>
          <td>
            <EditableField
              type="cleaningrate"
              pallet={pallet}
              store={store}
              configStore={configStore}
              userid={authStore.user.Id}
              socket={socket}
            />
          </td>
          <td>
            <EditableField
              type="supplier"
              pallet={pallet}
              store={store}
              configStore={configStore}
              userid={authStore.user.Id}
              socket={socket}
              showPopup={(text) => this.showPopup(text)}
            />
          </td>
          <td className={pallet.HasMixedItems ? " blue-text" : ""}>
            {pallet.ItemName} {pallet.CustomItem ? <br /> : null}{" "}
            {pallet.CustomItem ? "(" + pallet.CustomItem + ")" : ""}
          </td>
          {pallet.BinCode || true ? (
            <td
              className="table-cell-active"
              onClick={() => {
                if (pallet.BinCode)
                  router.navigate(ROUTE_MAP, {
                    defaultDetailedBin: pallet.BinCode,
                  });
              }}
            >
              <EditableField
                type="bincode"
                pallet={pallet}
                store={store}
                configStore={configStore}
                userid={authStore.user.Id}
                socket={socket}
                showPopup={(text) => this.showPopup(text)}
              />
            </td>
          ) : (
            <td />
          )}
          <td>
            <EditableField
              type="quantity"
              pallet={pallet}
              store={store}
              configStore={configStore}
              userid={authStore.user.Id}
              socket={socket}
              showPopup={(text) => this.showPopup(text)}
            />
          </td>
          <td>{pallet.QualityPurity ? pallet.QualityPurity + " %" : ""}</td>
          <td>{pallet.QualityGerm ? pallet.QualityGerm + " %" : ""}</td>
          <td>{pallet.QualityWater ? pallet.QualityWater + " %" : ""}</td>
          <td>{pallet.Created}</td>
          {showTerminated ? <td>{pallet.Terminated}</td> : null}
          {showTerminated ? (
            <td>
              <EditableField
                type="status"
                pallet={pallet}
                store={store}
                configStore={configStore}
                userid={authStore.user.Id}
                socket={socket}
                showPopup={(text) => this.showPopup(text)}
              />
            </td>
          ) : null}
        </tr>
      );
      rows.push(subtable);
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table-pager-amount">
              <PagerAmount
                perPage={pager.perPage}
                onChange={(e) => pager.setPerPage(e.value)}
              />
            </div>
            <div className="table-datepicker-block">
              Létrehozva&nbsp;
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.from}
                onChange={(date) => {
                  store.setFrom(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
              <div className="separator"></div>
              <DatePicker
                className="table input-date form-input"
                dateFormat="yyyy-MM-dd"
                selected={store.to}
                onChange={(date) => {
                  store.setTo(date);
                  this.refresh();
                }} /*locale='hu'*/
              />
            </div>
            <div className="table-checkbox-block">
              <input
                id="showTerminatedCheckbox"
                type="checkbox"
                name="showTerminated"
                value="showTerminated"
                checked={showTerminated}
                onClick={() => {
                  //store.changeShowTerminated();
                  const _this = this;
                  this.setState(
                    (prevState) => {
                      return { showTerminated: !prevState.showTerminated };
                    },
                    () => {
                      _this.refresh();
                    }
                  );
                }}
              />
              <label
                className="table-checkbox-label"
                htmlFor="showTerminatedCheckbox"
              >
                <span></span>
                <div className="table-checkbox-title">
                  Megszüntetettek mutatása
                </div>
              </label>
            </div>
            <TableSearch />
            <div className="table-upload">
              <label
                className={"btn table-upload__btn btn--upper btn--large"}
                onClick={() => this.handleDownload()}
              >
                excel letöltés
              </label>
            </div>
            <div className="table-upload">
              <label
                className={
                  "btn table-upload__btn btn--upper btn--large" +
                  (uploading ? " btn--disabled" : "")
                }
                htmlFor="upload-file"
                onMouseDown={(e) => {
                  if (uploading) {
                    e.preventDefault();
                  } else {
                    this.setUploading();
                  }
                }}
              >
                Minőség feltöltés{" "}
                <input
                  id="upload-file"
                  type="file"
                  onChange={(e) => {
                    console.log("onchange");
                    this.onFileChange(e);
                  }}
                />
              </label>
            </div>
            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
              newContentAvailable={this.state.newContentAvailable}
            />
          </div>
          {canColor ? (
            <div className="table-colorbar">
              <div className="table-colorbar__label">Szín szűrő</div>
              <Select
                className="react-select table-colorbar__select"
                options={colorFilterOptions}
                value={colorFilterOptions.find(
                  (option) => option.value === store.colorFilter
                )}
                onChange={(option) => store.setColorFilter(option.value)}
                formatOptionLabel={formatColorOption}
                isSearchable={false}
                styles={SelectStyle}
                components={{ DropdownIndicator }}
              />
              <div className="table-colorbar__separator" />
              <div className="table-checkbox-block table-colorbar__checkbox">
                <input
                  id="coloringCheckbox"
                  type="checkbox"
                  name="coloring"
                  checked={coloring}
                  onChange={() => this.toggleColoring()}
                />
                <label className="table-checkbox-label" htmlFor="coloringCheckbox">
                  <span></span>
                  <div className="table-checkbox-title">Színezés</div>
                </label>
              </div>
              {coloring ? (
                <React.Fragment>
                  <div className="table-colorbar__label">
                    {store.checked.length} raklap kijelölve
                  </div>
                  <Select
                    className="react-select table-colorbar__select"
                    options={colorOptions}
                    value={this.state.selectedColor}
                    onChange={(option) =>
                      this.setState({ selectedColor: option })
                    }
                    formatOptionLabel={formatColorOption}
                    isSearchable={false}
                    placeholder="Szín választása..."
                    styles={SelectStyle}
                    components={{ DropdownIndicator }}
                  />
                  <div
                    className={
                      "table_inrow_button table-colorbar__button" +
                      (store.checked.length && this.state.selectedColor
                        ? ""
                        : " disabled")
                    }
                    onClick={() =>
                      this.state.selectedColor &&
                      this.setColor(this.state.selectedColor.value)
                    }
                  >
                    Színez
                  </div>
                  <div
                    className={
                      "table_inrow_button table-colorbar__button" +
                      (store.checked.length ? "" : " disabled")
                    }
                    onClick={() => this.setColor(null)}
                  >
                    Szín törlése
                  </div>
                </React.Fragment>
              ) : null}
            </div>
          ) : null}
          <div className="table__content">
            <table>
              <thead>
                <tr>
                  {coloring ? (
                    <th className="table-select-col">
                      <div className="table-header-checkbox">
                        <div
                          className="table-header-select-button"
                          title="összes találat kijelölése"
                          onClick={() => store.setCheckedAll()}
                        >
                          <BiCheck size={16} />
                        </div>
                        <div
                          className="table-header-select-button"
                          title="kijelölés törlése"
                          onClick={() => store.resetCheckedPallets()}
                        >
                          X
                        </div>
                      </div>
                    </th>
                  ) : null}
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOTNO)}
                    >
                      Azonosító
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOTNO ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_MACHINE)}
                    >
                      Gép
                      <Sorter
                        activeDirection={
                          sortField === SORT_MACHINE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CLEANINGRATE)}
                    >
                      Fok
                      <Sorter
                        activeDirection={
                          sortField === SORT_CLEANINGRATE ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_SUPPLIER)}
                    >
                      Beszállító
                      <Sorter
                        activeDirection={
                          sortField === SORT_SUPPLIER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_ITEM)}
                    >
                      Cikk
                      <Sorter
                        activeDirection={
                          sortField === SORT_ITEM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_LOCATION)}
                    >
                      Hely
                      <Sorter
                        activeDirection={
                          sortField === SORT_LOCATION ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT)}
                    >
                      Mennyiség
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_QPURITY)}
                    >
                      Tisztaság
                      <Sorter
                        activeDirection={
                          sortField === SORT_QPURITY ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_QGERM)}
                    >
                      Csíra
                      <Sorter
                        activeDirection={
                          sortField === SORT_QGERM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_QWATER)}
                    >
                      Víz
                      <Sorter
                        activeDirection={
                          sortField === SORT_QWATER ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_CREATED)}
                    >
                      Létrehozva
                      <Sorter
                        activeDirection={
                          sortField === SORT_CREATED ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  {showTerminated ? (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_TERMINATED)}
                      >
                        Megszüntetve
                        <Sorter
                          activeDirection={
                            sortField === SORT_TERMINATED ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  ) : null}
                  {showTerminated ? (
                    <th>
                      <div
                        className="table__header-cell"
                        onClick={this.onClickSort(SORT_STATUS)}
                      >
                        Művelet
                        <Sorter
                          activeDirection={
                            sortField === SORT_STATUS ? sortDirection : null
                          }
                        />
                      </div>
                    </th>
                  ) : null}
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
          <div className="table__bottom">
            <div>
              {firstShownItem} - {lastShownItem} találat mutatása {itemCount}{" "}
              közül
            </div>
            <Pager
              routeName={routeName}
              routeParams={routeParams}
              pager={pager}
              onClickPage={(page) => pager.setCurrentPage(page)}
            />
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

class EditableField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
      editmode: false,
    };
  }

  componentDidMount() {
    this.resetInputs();
  }

  resetInputs = () => {
    const { type, pallet, configStore } = this.props;
    //console.log(type, pallet);
    switch (type) {
      case "machine":
        this.setState({
          machine: {
            value: pallet.MachineId,
            label: configStore.machines[pallet.MachineId].Name,
          },
          cleaningcount: pallet.CleaningCount.toString(),
        });
        break;

      case "cleaningrate":
        let sealnums = null;
        let sealnum = null;
        if (pallet.CleaningRate === 4) {
          sealnum = { value: pallet.SealNum, label: pallet.SealNum };
        }

        this.setState({
          cleaningrate: {
            value: pallet.CleaningRate,
            label: configStore.cleaningRates[pallet.CleaningRate],
          },
          customcleaningrate: pallet.CustomCleaningRate,
          sealnums: sealnums,
          sealnum: sealnum,
        });
        break;

      case "supplier":
        this.setState({
          supplier: {
            value: pallet.SupplierId,
            label: configStore.suppliers[pallet.SupplierId],
          },
          customsupplier: pallet.CustomSupplier,
        });
        break;

      case "bincode":
        this.setState(() => {
          let _bin = null;
          let level = null;
          let levels = null;
          if (pallet.BinCode) {
            _bin = configStore.bins.find((b) => b.name === pallet.BinCode);
          }

          if (pallet.Level) {
            level = { value: pallet.Level, label: pallet.Level };
          }

          if (_bin && _bin.levelnum > 1) {
            levels = [];
            for (let i = 0; i < _bin.levelnum; i++) {
              levels.push({ value: i, label: i });
            }
          }

          return {
            bin: _bin ? { value: _bin.id, label: _bin.name } : null,
            level: level,
            levels: levels,
          };
        });
        break;

      case "quantity":
        this.setState({
          bagtype:
            pallet.BagType === 1
              ? configStore.bagtypes[0]
              : configStore.bagtypes[1],
          bagcount: pallet.BagCount,
          quantity: pallet.Quantity,
        });
        break;

      case "status":
        this.setState({
          status: {
            value: pallet.Status,
            label: configStore.palletstatuses[pallet.Status],
          },
        });
        break;
    }
  };

  handleSave = () => {
    const { type, pallet, store, socket, showPopup, userid } = this.props;

    const _pallet = JSON.parse(JSON.stringify(pallet));

    let data = { UserId: userid, PalletId: pallet.Id };

    switch (type) {
      case "machine":
        if (
          this.state.machine &&
          this.state.cleaningcount &&
          !isNaN(this.state.cleaningcount)
        ) {
          data.DataType = "Machine";
          _pallet.MachineId = this.state.machine.value;
          _pallet.CleaningCount = this.state.cleaningcount;
          data.Data = {
            MachineId: _pallet.MachineId,
            CleaningCount: _pallet.CleaningCount,
          };
        } else {
          data = null;
        }
        break;

      case "cleaningrate":
        if (this.state.cleaningrate) {
          data.DataType = "CleaningRate";
          _pallet.CleaningRate = this.state.cleaningrate.value;
          _pallet.CustomCleaningRate = this.state.customcleaningrate
            ? this.state.customcleaningrate
            : null;
          _pallet.SealNum = this.state.sealnum
            ? this.state.sealnum.value
            : null;
          data.Data = {
            CleaningRate: _pallet.CleaningRate,
            CustomCleaningRate: _pallet.CustomCleaningRate,
            SealNum: _pallet.SealNum,
          };
        } else {
          data = null;
        }
        break;

      case "supplier":
        if (this.state.supplier) {
          data.DataType = "SupplierId";
          _pallet.SupplierId = this.state.supplier.value;
          _pallet.CustomSupplier =
            this.state.customsupplier && this.state.supplier.value == 740
              ? this.state.customsupplier
              : null;
          data.Data = {
            SupplierId: _pallet.SupplierId,
            CustomSupplier: _pallet.CustomSupplier,
          };
        } else {
          data = null;
        }
        break;

      case "bincode":
        if (this.state.bin) {
          data.DataType = "BinId";
          _pallet.BinCode = this.state.bin.label;
          _pallet.Level = this.state.level
            ? parseInt(this.state.level.label)
            : null;
          data.Data = {
            BinId: this.state.bin.value,
            Level:
              this.state.level != null && this.state.level.value >= 0
                ? this.state.level.value
                : null,
          };
        } else {
          data = null;
        }
        break;

      case "quantity":
        if (
          this.state.bagtype &&
          !isNaN(this.state.bagcount) &&
          !isNaN(this.state.quantity)
        ) {
          data.DataType = "Quantity";
          _pallet.BagType = this.state.bagtype.value;
          _pallet.BagCount =
            this.state.bagtype.value === 2 ? this.state.bagcount : 1;
          _pallet.Quantity = this.state.quantity;
          data.Data = {
            BagType: _pallet.BagType,
            BagCount: _pallet.BagCount,
            Quantity: _pallet.Quantity,
          };
        } else {
          data = null;
        }
        break;

      case "status":
        if (this.state.status) {
          console.log(this.state);
          data.DataType = "Status";
          _pallet.Status = this.state.status.value;
          if (_pallet.Status === 0) {
            _pallet.Terminated = null;
          } else {
            _pallet.Terminated = new Date();
          }
          data.Data = {
            Status: _pallet.Status,
            Terminated: _pallet.Terminated,
          };
        } else {
          data = null;
        }
        break;
    }

    if (data) {
      socket.emitWithToken(
        "SetPalletProperty",
        data,
        function (err, data) {
          console.log(err, data);
          if (err) {
            console.error(err);
            showPopup(err);
          } else if (data) {
            console.log(_pallet);
            store.setItem(_pallet);
          }
          this.setState({ editmode: false });
        }.bind(this)
      );
    } else {
      console.log("hibás kitöltés");
      showPopup("A mezők kitöltése nem megfelelő.");
    }
  };

  render() {
    const { type, pallet, configStore, store } = this.props;

    let data;
    let editdata;
    switch (type) {
      case "machine":
        data = (
          <span>
            {pallet.MachineText} {pallet.Dressing ? <br /> : null}{" "}
            {pallet.Dressing ? "(" + pallet.Dressing + ")" : null}
          </span>
        );
        editdata = (
          <div className="edit_inputs">
            <Select
              className="react-select"
              options={Object.entries(configStore.machines).map(
                ([id, machine]) => ({ value: id, label: machine.Name })
              )}
              onChange={(e) => this.setState({ machine: e })}
              value={this.state.machine}
              isSearchable={true}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
            <input
              className="edit_textinput"
              value={this.state.cleaningcount}
              onChange={(e) => this.setState({ cleaningcount: e.target.value })}
            />
          </div>
        );
        break;

      case "cleaningrate":
        data =
          pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : "");
        let sealnumoptions = store.sealnums.map((sealnum) => {
          return { value: sealnum, label: sealnum };
        });
        if (
          this.state.sealnum &&
          store.sealnums.indexOf(this.state.sealnum.value) === -1
        )
          sealnumoptions = sealnumoptions.concat(this.state.sealnum);
        editdata = (
          <div className="edit_inputs">
            <Select
              className="react-select"
              options={Object.entries(configStore.cleaningRates).map(
                ([id, cleaningrate]) => ({
                  value: id,
                  label: cleaningrate,
                })
              )}
              onChange={(e) => this.setState({ cleaningrate: e })}
              value={this.state.cleaningrate}
              isSearchable={true}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
            {this.state.cleaningrate &&
              parseInt(this.state.cleaningrate.value) === 4 && (
                <Select
                  className="react-select"
                  options={sealnumoptions}
                  onChange={(e) => this.setState({ sealnum: e })}
                  value={this.state.sealnum}
                  styles={SelectStyle}
                  components={{ DropdownIndicator }}
                  placeholder=""
                />
              )}
            {this.state.cleaningrate &&
              parseInt(this.state.cleaningrate.value) === 5 && (
                <input
                  className="edit_textinput"
                  value={this.state.customcleaningrate}
                  onChange={(e) =>
                    this.setState({ customcleaningrate: e.target.value })
                  }
                />
              )}
          </div>
        );
        break;

      case "supplier":
        data =
          pallet.Supplier +
          (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : "");
        editdata = (
          <div className="edit_inputs">
            <Select
              className="react-select"
              options={Object.entries(configStore.suppliers).map(
                ([id, supplier]) => ({
                  value: id,
                  label: supplier,
                })
              )}
              onChange={(e) => this.setState({ supplier: e })}
              value={this.state.supplier}
              isSearchable={true}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
            {this.state.supplier &&
              parseInt(this.state.supplier.value) === 740 && (
                <input
                  className="edit_textinput"
                  value={this.state.customsupplier}
                  onChange={(e) =>
                    this.setState({ customsupplier: e.target.value })
                  }
                />
              )}
          </div>
        );
        break;

      case "bincode":
        data = pallet.BinCode;
        if (pallet.BinCode && pallet.Level != null) data += "/" + pallet.Level;

        let bin;
        let levels = null;
        if (pallet.BinCode)
          bin = configStore.bins.find((b) => b.name === pallet.BinCode);
        if (bin && bin.levelnum > 1) {
          levels = [];
          for (let i = 0; i < bin.levelnum; i++) {
            levels.push({ value: i, label: i });
          }
          //this.setState({ levels: levels });
        }
        //console.log(this.state);
        editdata = (
          <div className="edit_inputs">
            <Select
              className="react-select select-wide-dropdown"
              options={configStore.bins.map((bin) => ({
                value: bin.id,
                label: bin.name,
              }))}
              onChange={(e) => {
                let bin = configStore.bins.find((b) => b.id === e.value);
                let levels = null;

                if (bin && bin.levelnum && bin.levelnum > 1) {
                  levels = [];
                  for (let i = 0; i < bin.levelnum; i++) {
                    levels.push({ value: i, label: i });
                  }
                }

                console.log(configStore.bins, bin, levels);

                this.setState({ bin: e, level: null, levels: levels });
              }}
              value={this.state.bin}
              isSearchable={true}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
            {(this.state.levels ||
              (this.state.levels === undefined && levels)) && (
              <Select
                className="react-select"
                options={
                  this.state.levels === undefined ? levels : this.state.levels
                }
                onChange={(e) => this.setState({ level: e })}
                value={this.state.levels ? this.state.level : null}
                isSearchable={false}
                styles={SelectStyle}
                components={{ DropdownIndicator }}
              />
            )}
          </div>
        );
        break;

      case "quantity":
        data =
          (pallet.BagType === 2
            ? pallet.BagCount + " x " + pallet.Quantity
            : pallet.Quantity) + " kg";
        editdata = (
          <div className="edit_inputs">
            <Select
              className="react-select"
              options={configStore.bagtypes}
              onChange={(e) => this.setState({ bagtype: e })}
              value={this.state.bagtype}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
            {this.state.bagtype && this.state.bagtype.value === 2 && (
              <div className="edit_textinput_wrapper db">
                <input
                  className="edit_textinput"
                  value={this.state.bagcount}
                  onChange={(e) => this.setState({ bagcount: e.target.value })}
                />
              </div>
            )}
            <div className="edit_textinput_wrapper kg">
              <input
                className="edit_textinput"
                value={this.state.quantity}
                onChange={(e) => this.setState({ quantity: e.target.value })}
              />
            </div>
          </div>
        );
        break;

      case "status":
        data =
          pallet.Status !== 0
            ? configStore.palletstatuses[pallet.Status]
            : null;
        let statusoptions = [
          { value: 0, label: configStore.palletstatuses[0] },
          {
            value: pallet.Status,
            label: configStore.palletstatuses[pallet.Status],
          },
        ];
        editdata = (
          <div className="edit_inputs">
            {status}
            <Select
              className="react-select"
              options={Object.keys(configStore.palletstatuses).map((key) => ({
                value: parseInt(key),
                label: configStore.palletstatuses[key],
              }))}
              onChange={(e) => this.setState({ status: e })}
              value={this.state.status}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
          </div>
        );
        break;
    }

    if (this.state.editmode) {
      console.log(configStore.bins, this.state);
    }

    return this.state.editmode ? (
      <div className="editfield" onClick={(e) => e.stopPropagation()}>
        {editdata}
        <div className="edit_controls">
          <i
            className="far fa-times-circle editbutton"
            onClick={() => {
              this.setState({ editmode: false });
            }}
          ></i>
          <i
            className="fas fa-save editbutton"
            onClick={() => this.handleSave()}
          ></i>
        </div>
      </div>
    ) : (
      <div
        className="editablefield"
        onMouseOver={() =>
          (pallet.Status === 0 || type === "status") &&
          this.setState({ hover: true })
        }
        onMouseLeave={() => this.setState({ hover: false })}
      >
        {data ? data : "..."}
        {this.state.hover && (
          <i
            className="fas fa-pen editbutton"
            onMouseOver={(e) => {
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.stopPropagation();
              this.resetInputs();
              this.setState({ editmode: true, hover: false });
            }}
          ></i>
        )}
      </div>
    );
  }
}

export {
  SORT_ASC,
  SORT_DESC,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_STATUS,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_QPURITY,
  SORT_QALIENSEED,
  SORT_QHARDSEED,
  SORT_QGERM,
  SORT_QWATER,
};

export default (props) => (
  <RouteNode nodeName={ROUTE_TABLE}>
    {(routeProps) => <Table {...routeProps} {...props} />}
  </RouteNode>
);
